"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CwLog = require("./services/CwLog");

var _CwLog2 = _interopRequireDefault(_CwLog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDialog = function getDialog(dialogID) /*props = null*/{
  switch (dialogID) {

    default:
      _CwLog2.default.error("No dialog found for " + dialogID);
  }
}; // import React from 'react';
// import AsyncComponent from './components/async/AsyncComponent';
exports.default = getDialog;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/DialogFactory.js
// module id = 740
// module chunks = 10